<template>
    <component :is="tag" :to="to" :href="href" :type="tag === 'button' ? (type || 'button') : undefined"
        :disabled="disabled" :class="classes">
        <slot />
    </component>
</template>

<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

const props = defineProps({
    variant: { type: String, default: 'primary' }, // primary | secondary | outline | ghost
    size: { type: String, default: 'md' }, // sm | md | lg
    to: { type: [String, Object], default: null },
    href: { type: String, default: null },
    type: { type: String, default: 'button' },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
});

const tag = computed(() => {
    if (props.to) return RouterLink;
    if (props.href) return 'a';
    return 'button';
});

const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-7 py-3.5 text-base',
};

const variants = {
    primary: 'bg-primary-600 text-white shadow-sm shadow-primary-600/20 hover:bg-primary-500 focus-visible:outline-primary-600',
    accent: 'bg-accent-500 text-white shadow-sm shadow-accent-500/20 hover:bg-accent-400 focus-visible:outline-accent-500',
    secondary: 'bg-gray-900 text-white shadow-sm hover:bg-gray-800 focus-visible:outline-gray-900',
    outline: 'bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-gray-400',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 focus-visible:outline-gray-400',
};

const classes = computed(() => [
    'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors duration-150',
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
    'disabled:cursor-not-allowed disabled:opacity-50',
    sizes[props.size] || sizes.md,
    variants[props.variant] || variants.primary,
    props.block ? 'w-full' : '',
]);
</script>
